module.exports = __webpack_public_path__ + "img/email.d5ce431b.svg";